import React from 'react';
import './test.css';
import { Button, Grid, Modal } from 'semantic-ui-react'
import LandingVideoModal from './LandingVideoModals.js'

const linkStyling = {
  marginBottom: '5px'
}

export const Landing = (props) => {
  return (
    <div style={{width: '90%', marginLeft: '1%'}}>
      <Grid columns={4} divided>
        <Grid.Row style={{marginBottom: '0px', fontSize: '16px', fontWeight: '600', marginTop: '20px'}}>
          <Grid.Column>
            1. Intro video
          </Grid.Column>
          <Grid.Column>
            2. Potential Products Columns Overview
          </Grid.Column>
          <Grid.Column>
            3. Matching Product Listing to Wholesale Price Sheet Example
          </Grid.Column>
          <Grid.Column>
            4. Items Per ASIN Example
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Modal trigger={<img width="325" height="220" title="intro" src="https://img.youtube.com/vi/i0clpZ2wQq8/maxresdefault.jpg" />} closeIcon>
              <Modal.Content>
                <Modal.Description>
                  <iframe title="intro" width="850" height="600" src="https://www.youtube.com/embed/i0clpZ2wQq8" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Grid.Column>
          <Grid.Column>
            <Modal trigger={<img width="325" height="220" title="intro" src="https://img.youtube.com/vi/JwzKg6bnhgk/maxresdefault.jpg" />} closeIcon>
              <Modal.Content>
                <Modal.Description>
                  <iframe title="intro" width="850" height="600" src="https://www.youtube.com/embed/JwzKg6bnhgk" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Grid.Column>
          <Grid.Column>
            <Modal trigger={<img width="325" height="220" title="intro" src="https://img.youtube.com/vi/Nes156zZPdc/maxresdefault.jpg" />} closeIcon>
              <Modal.Content>
                <Modal.Description>
                  <iframe title="intro" width="850" height="600" src="https://www.youtube.com/embed/Nes156zZPdc" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Grid.Column>
          <Grid.Column>
            <Modal trigger={<img width="325" height="220" title="intro" src="https://img.youtube.com/vi/d7snVKaCDNw/maxresdefault.jpg" />} closeIcon>
              <Modal.Content>
                <Modal.Description>
                  <iframe title="intro" width="850" height="600" src="https://www.youtube.com/embed/d7snVKaCDNw" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Grid.Column>
        </Grid.Row>
      </Grid>
        
      <div style={{marginTop: '5px', marginBottom: '10px'}}>
        <div style={linkStyling}>
          <a href="https://docs.google.com/document/d/1D06mwUFhCCWG0j6Bbh64Bfr_kSoCQfgbic4c-qQNuX8" target="_blank" rel="noopener noreferrer">Potential Products Columns Overview</a>
        </div>
        <div style={linkStyling}>
          <a href="https://docs.google.com/document/d/1_M3B9mU1lX6hHvF2Q3slQ4nubWZqWnB0glIOfCdI7J4" target="_blank" rel="noopener noreferrer">Potential Products Products Checklist</a>
        </div>
        <div style={linkStyling}>
          <a href="https://docs.google.com/document/d/1SoVcJw_x0xlspvtatJgTFLgNAf1AZgDK1YubCfdXTNg" target="_blank" rel="noopener noreferrer">Items per ASIN Example</a>
        </div>
        <div style={linkStyling}>
          <a href="https://docs.google.com/document/d/1-JVe49FN0DY-yehNXEaA1u1xbcojO-BzabbpvCAqDwk" target="_blank" rel="noopener noreferrer">Matching Product Listing to Wholesale Price Sheet</a>
        </div>
      </div>
      <Button primary onClick={props.landingContinue}>Start Test</Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/landing.js